import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericService } from './generic.service';

@Injectable({
  providedIn: 'root'
})
export class UsuarioService extends GenericService {

  constructor(http: HttpClient) {
    super(http, 'usuario');
  }

  resetSenha(email: any): Observable<any> {
    return this.http.post(`${this.url_base}/${this.prefixo}/reset-senha/${email}`, null);
  }

  enviarConvite(id: number): Observable<any> {
    return this.http.post(`${this.url_base}/${this.prefixo}/${id}/enviar-convite`, null);
  }

  listarUsuarios(): Observable<any> {
    const params = new HttpParams().set('tipo', '0');
    return this.http.get(`${this.url_base}/${this.prefixo}`, { params });
  }

  listarAPIs(): Observable<any> {
    const params = new HttpParams().set('tipo', '1');
    return this.http.get(`${this.url_base}/${this.prefixo}`, { params });
  }

  storeMultipart(formData: FormData): Observable<any> {
    return this.http.post(`${this.url_base}/${this.prefixo}`, formData);
  }

  updateMultipart(formData: FormData, id: number): Observable<any> {
    formData.append('_method', 'PUT');
    return this.http.post(`${this.url_base}/${this.prefixo}/${id}`, formData);
  }

}
